import { Component, Input, ElementRef, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';

@Component({
    selector: 'al-gmc-flyout',
    templateUrl: './al-gmc-flyout.component.html'
})
export class AlGMCFlyoutComponent implements AfterViewInit {

    // GMC Flyout Header message.
    @Input() headerMessage: string = 'Message';

    // Title for close button
    @Input() closeButtonTitle: string = 'Click this button to close the window';

    // Aria label for close button
    @Input() closeButtonAriaLabel: string = 'Close Messages Window';

    public focusedElBeforeOpen: Element;
    public focusableEls: any;
    hiddenElement: boolean = true;

    /**
     * @constructs
     * Setting constructor method and required param
     *
     * @param _element
     * @param cdr
     */
    constructor(private _element: ElementRef, private cdr: ChangeDetectorRef) { }

    /**
     * @HostListener
     * Setting hostlistener on window resize event for width adjustment of flyout
     *
     * @param event
     */
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.GMCCalulation();
    }

    /**
     * Show GMC Flyout and binds accessibility.
     * @method showGMCFlyout
     */
    showGMCFlyout() {
        this.hiddenElement = false;
        // document.body.style.overflow = 'hidden';
        this.manageAccessibility();
        if (document.querySelector('#al-gmc-messages-link')) {
            document.querySelector('#al-gmc-messages-link').classList.add('al-gmc-flyout-visible');
        }
    }

    /**
     * Making flyout accessible with keyboard for Accessibility
     * Preventing focus to jump outside of flyout while pressing tab key
     *
     * @method manageAccessibility
     *
     */
    manageAccessibility() {
        setTimeout(() => {
            this._element.nativeElement.setAttribute('role', 'dialog');

            let focusableEls = this._element.nativeElement.querySelectorAll('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
            this.focusableEls = Array.prototype.slice.call(focusableEls);

            let firstElement = this.focusableEls[0];
            let getLength = this.focusableEls.length - 1;
            let lastElement = this.focusableEls[getLength];

            /* check last and first element of dialog is focusable or not */
            /* istanbul ignore if */
            if (lastElement && firstElement) {

                /*redirect last tab to first input*/
                lastElement.addEventListener('keydown', (e) => {
                    if ((e.which === 9 && !e.shiftKey)) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                });

                /*redirect first shift+tab to last input*/
                firstElement.addEventListener('keydown', (e) => {
                    if ((e.which === 9 && e.shiftKey)) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                });
            }
        }, 100);
    }

    /**
     * Sets the width property for GMC flyout on the base of available width
     * @method GMCCalulation
     *
     */
    GMCCalulation() {
        /* istanbul ignore if */
        if (document.querySelector('html').classList.contains('al-view-gt960')) {
            this._element.nativeElement.querySelector('#alFlyout').style.width = (50 / 100) * document.documentElement.clientWidth + 'px';
        } else if (document.querySelector('html').classList.contains('al-view-720')) {
            this._element.nativeElement.querySelector('#alFlyout').style.width = (56 / 100) * document.documentElement.clientWidth + 'px';
        } else {
            this._element.nativeElement.querySelector('#alFlyout').style.width = (88.75 / 100) * document.documentElement.clientWidth + 'px';
        }
    }

    /**
     * Close GMC flyout method
     * @method closeGMCFlyout
     *
     */
    closeGMCFlyout() {
        this.hiddenElement = true;
        document.body.setAttribute('tabindex', '0');
        document.body.focus();
        document.body.removeAttribute('tabindex');
        document.body.style.overflow = '';
        if (document.querySelector('#al-gmc-messages-link')) {
            document.querySelector('#al-gmc-messages-link').classList.remove('al-gmc-flyout-visible');
        }
        if (window['alIntroOverlay'] && typeof window['alIntroOverlay'] === 'function') {
            window['alIntroOverlay']();
        } else {
            if (typeof window['ahIntroOverlay'] === 'function') {
                window['ahIntroOverlay']();
            }
        }
    }

    /**
     * Sets the GMC flyout view is initialized or not
     * @event ngAfterViewInit
     */
    ngAfterViewInit() {
        this.showGMCFlyout();
        this.GMCCalulation();
        this.cdr.detectChanges();
    }

}
